import { render, staticRenderFns } from "./MarkAsPaidModal.vue?vue&type=template&id=13bbff46"
import script from "./MarkAsPaidModal.vue?vue&type=script&lang=js"
export * from "./MarkAsPaidModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports